module.exports = __webpack_public_path__ + "static/media/portland_state_dsc_logo.959e8c06.png";